const onboardingSteps = [
  {
    id: 'welcome',
    target: null,
    position: 'center',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'sidebar',
    target: '[data-tour="sidebar"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'dashboard-stats',
    target: '[data-tour="stats-grid"]',
    position: 'bottom',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'quick-actions',
    target: '[data-tour="quick-actions"]',
    position: 'bottom',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'offers',
    target: '[data-tour="nav-offers"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'requests',
    target: '[data-tour="nav-requests"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'network',
    target: '[data-tour="nav-network"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'catalog',
    target: '[data-tour="nav-catalog"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'statistics',
    target: '[data-tour="nav-statistics"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'settings',
    target: '[data-tour="nav-settings"]',
    position: 'left',
    roles: ['all'],
    route: '/dashboard',
  },
  {
    id: 'complete',
    target: null,
    position: 'center',
    roles: ['all'],
    route: '/dashboard',
  },
];

export const getStepsForRole = (role) => {
  return onboardingSteps.filter(
    (step) => step.roles.includes('all') || step.roles.includes(role)
  );
};

export const offerTourSteps = [
  { id: 'offer-intro',    target: null,                                    position: 'center', tourId: 'offers',   route: '/offers'   },
  { id: 'offer-add-btn',  target: '[data-tour="add-offer-btn"]',           position: 'bottom', tourId: 'offers',   route: '/offers'   },
  // The add button navigates before the tour targets the standalone create form.
  { id: 'offer-method',   target: '[data-tour="offer-form"]',              position: 'bottom', tourId: 'offers',   route: '/offers/new' },
  { id: 'offer-form',     target: null,                                    position: 'center', tourId: 'offers',   route: '/offers/new' },
  { id: 'offer-done',     target: null,                                    position: 'center', tourId: 'offers',   route: '/offers'   },
];

export const requestTourSteps = [
  { id: 'request-intro',   target: null,                                   position: 'center', tourId: 'requests', route: '/requests' },
  { id: 'request-add-btn', target: '[data-tour="add-request-btn"]',        position: 'bottom', tourId: 'requests', route: '/requests' },
  // The add button navigates before the tour targets the standalone request form.
  { id: 'request-method',  target: '[data-tour="request-form"]',           position: 'bottom', tourId: 'requests', route: '/requests/new' },
  { id: 'request-form',    target: null,                                   position: 'center', tourId: 'requests', route: '/requests/new' },
  { id: 'request-done',    target: null,                                   position: 'center', tourId: 'requests', route: '/requests' },
];

export const matchingTourSteps = [
  { id: 'matching-intro',  target: null,                                   position: 'center', tourId: 'matching', route: '/requests' },
  { id: 'matching-list',   target: '[data-tour="matching-tab"]',           position: 'bottom', tourId: 'matching', route: '/requests' },
  { id: 'matching-result', target: '[data-tour="matching-result"]',        position: 'bottom', tourId: 'matching', route: '/requests' },
  { id: 'matching-done',   target: null,                                   position: 'center', tourId: 'matching', route: '/requests' },
];

export const catalogTourSteps = [
  { id: 'catalog-intro',   target: null,                                   position: 'center', tourId: 'catalog',  route: '/catalog'  },
  { id: 'catalog-create',  target: '[data-tour="create-catalog-btn"]',     position: 'bottom', tourId: 'catalog',  route: '/catalog'  },
  { id: 'catalog-setup',   target: null,                                   position: 'center', tourId: 'catalog',  route: '/catalog'  },
  { id: 'catalog-save',    target: '[data-tour="catalog-save"]',           position: 'bottom', tourId: 'catalog',  route: '/catalog'  },
  { id: 'catalog-share',   target: '[data-tour="catalog-share"]',          position: 'bottom', tourId: 'catalog',  route: '/catalog'  },
  { id: 'catalog-done',    target: null,                                   position: 'center', tourId: 'catalog',  route: '/catalog'  },
];

export const getTourById = (tourId) => {
  const tours = {
    offers: offerTourSteps,
    requests: requestTourSteps,
    matching: matchingTourSteps,
    catalog: catalogTourSteps,
  };
  return tours[tourId] || [];
};

export default onboardingSteps;
